import { message } from "antd";
import { MediaPurpose } from "@/utils/enum";
import { updateDocument } from "@/services/media";
import { getNotesCount } from "@/services/notes";
import {
  getUser,
  deleteUser,
  addDealerEntity,
  addTransporterEntity,
  removeEntityConnection,
  updateRoles,
} from "@/services/user";
import {
  updateUser,
  getUserById,
  resetUserPassword,
  toggleUserActivate,
  updateProfilePhoto,
  unlockUser,
} from "@/services/users_new";

const Model = {
  namespace: "singleuser",
  state: {
    data: null,
    count: {
      notes: 0,
    },
  },
  effects: {
    *fetchSingleUser({ userId }, { call, put }) {
      const response = yield call(getUserById, userId);

      yield put({
        type: "show",
        payload: response || null,
      });
    },
    *fetchUserTabCounts({ userId, notes }, { put, call, select }) {
      let notesCount;

      if (notes) {
        notesCount = yield call(getNotesCount, userId);
      }

      const { oldNotesCount } = yield select(state => ({
        oldNotesCount: state.singleuser.count.notes,
      }));

      yield put({
        type: "setTabCounts",
        notesCount,
        oldNotesCount,
      });
    },
    *editSingleUser({ userId, payload }, { call, put, select }) {
      try {
        yield call(updateUser, userId, payload);
        const response = yield call(getUserById, userId);

        yield put({
          type: "show",
          payload: response || null,
        });

        const { oldNotesCount } = yield select(state => ({
          oldNotesCount: state.singleuser.count.notes,
        }));

        const notesCount = yield call(getNotesCount, userId);

        yield put({
          type: "setTabCounts",
          notesCount,
          oldNotesCount,
        });

        return response;
      } catch (error) {
        return { error };
      }
    },
    *updatePicProfile({ userId, payload }, { call, put }) {
      try {
        const update = yield call(updateDocument, payload, MediaPurpose.ProfilePicture);
        yield call(updateProfilePhoto, {
          userId,
          profilePhotoUri: update.url,
        });

        yield put({
          type: "setProfilePicture",
          profilePictureUrl: update.url,
        });

        return update.url;
      } catch (error) {
        message.error("Something went wrong uploading the profile picture");
        return { error };
      }
    },
    *unlock({ userId }, { call, put }) {
      try {
        yield call(unlockUser, userId);
        yield put({
          type: "userUnlocked",
        });
      } catch (error) {
        throw new Error(error);
      }
    },
    *resetPassword({ payload }, { call, put }) {
      yield call(resetUserPassword, payload);
      const response = yield call(getUserById, payload.userId);
      yield put({
        type: "show",
        payload: response,
      });
    },
    *deleteUser({ payload }, { call, select }) {
      const userMngr = yield select(state => state.user.userManager);
      yield call(deleteUser, userMngr, payload);
    },
    *toggleUserActivation({ payload }, { call, put }) {
      yield call(toggleUserActivate, payload);
      const response = yield call(getUserById, payload.userId);

      yield put({
        type: "show",
        payload: response,
      });
    },
    *addEntityToUser({ entityId, userId, userType }, { call, put, select }) {
      const userMngr = yield select(state => state.user.userManager);
      if (parseInt(userType, 10) === 0) {
        yield call(addTransporterEntity, userMngr, entityId, userId);
      } else {
        yield call(addDealerEntity, userMngr, entityId, userId);
      }
      const response = yield call(getUser, userMngr, userId);
      yield put({
        type: "show",
        payload: response,
      });
    },
    *removeEntityFromUser({ entityId, userId }, { call, put, select }) {
      const userMngr = yield select(state => state.user.userManager);
      const responseSuccess = yield call(removeEntityConnection, userMngr, entityId, userId);
      const response = yield call(getUser, userMngr, userId);
      yield put({
        type: "show",
        payload: response,
      });

      return responseSuccess;
    },
    *editUserEntityRoles({ payload }, { call, put, select }) {
      const userMngr = yield select(state => state.user.userManager);
      yield call(updateRoles, userMngr, payload);
      const response = yield call(getUser, userMngr, payload.userId);
      yield put({
        type: "show",
        payload: response,
      });
    },
  },
  reducers: {
    show(state, { payload }) {
      return {
        ...state,
        data: payload,
      };
    },
    setTabCounts(state, { notesCount, oldNotesCount }) {
      return {
        ...state,
        count: {
          notes: typeof notesCount === "number" ? notesCount : oldNotesCount,
        },
      };
    },
    userUnlocked(state) {
      return {
        ...state,
        data: {
          ...state.data,
          lockoutEnd: null,
        },
      };
    },
  },
};

export default Model;
